import { ReactElement } from 'react';

import { getProductHyperlink } from '@changegps/horizon-component-library';
import { To } from 'react-router-dom';

import ChecklistIcon from '../assets/checklist.svg?react';
import ConversationIcon from '../assets/conversation.svg?react';
import InstitutionIcon from '../assets/institution.svg?react';
import UserIcon from '../assets/user.svg?react';
import UsersIcon from '../assets/users.svg?react';
import { Icon } from '../components/Icon';

export const EXPLORE_CONTENT: {
  title: string;
  description: string;
  icon: ReactElement;
  tags: { label: string; to: To }[];
}[] = [
  {
    title: 'Client engagement',
    description:
      "Tools to enhance your firm's pricing strategies, streamline client onboarding, and foster professional client relationships.",
    tags: [
      {
        label: 'Engage',
        to: getProductHyperlink({
          environment: ENV.ENVIRONMENT,
          product: 'engage',
        }),
      },
      {
        label: 'Core: Resources',
        to: getProductHyperlink({
          environment: ENV.ENVIRONMENT,
          product: 'core',
          subProduct: 'resources',
        }),
      },
    ],
    icon: <Icon icon={<UserIcon />} />,
  },
  {
    title: 'Compliance',
    description:
      'Workpapers, templates, reports and more to support compliance tasks, ensuring adherence to industry standards and best practices.',
    tags: [
      {
        label: 'Core: FBT Report & Decs',
        to: getProductHyperlink({
          environment: ENV.ENVIRONMENT,
          product: 'core',
          subProduct: 'fbt',
        }),
      },
      {
        label: 'Core: Div Statements',
        to: getProductHyperlink({
          environment: ENV.ENVIRONMENT,
          product: 'core',
          subProduct: 'div-statements',
        }),
      },
      {
        label: 'Core: Trust Distributions',
        to: getProductHyperlink({
          environment: ENV.ENVIRONMENT,
          product: 'core',
          subProduct: 'trust-distribution',
        }),
      },
    ],
    icon: <Icon icon={<ChecklistIcon />} />,
  },
  {
    title: 'Advisory',
    description:
      'Resources and reports to provide strategic guidance and advice, helping clients achieve their financial and business goals.',
    tags: [
      {
        label: 'TaxPlan',
        to: getProductHyperlink({
          environment: ENV.ENVIRONMENT,
          product: 'taxplan',
        }),
      },
      {
        label: 'Core: Structure Advice',
        to: getProductHyperlink({
          environment: ENV.ENVIRONMENT,
          product: 'core',
          subProduct: 'structure',
        }),
      },
      {
        label: 'Core: CGT Advice',
        to: getProductHyperlink({
          environment: ENV.ENVIRONMENT,
          product: 'core',
          subProduct: 'cgt-advice',
        }),
      },
      {
        label: 'Core: Blueprint',
        to: getProductHyperlink({
          environment: ENV.ENVIRONMENT,
          product: 'core',
          subProduct: 'blueprint',
        }),
      },
      {
        label: 'Protect',
        to: getProductHyperlink({
          environment: ENV.ENVIRONMENT,
          product: 'protect',
        }),
      },
      {
        label: 'Core: Resources',
        to: getProductHyperlink({
          environment: ENV.ENVIRONMENT,
          product: 'core',
          subProduct: 'resources',
        }),
      },
    ],
    icon: <Icon icon={<ConversationIcon />} />,
  },
  {
    title: 'Client management',
    description:
      'Solutions to provide ongoing client education and management, ensuring effective delivery of accounting services.',
    tags: [
      {
        label: 'Engage',
        to: getProductHyperlink({
          environment: ENV.ENVIRONMENT,
          product: 'engage',
        }),
      },
      {
        label: 'Core: Service plan',
        to: getProductHyperlink({
          environment: ENV.ENVIRONMENT,
          product: 'core',
          subProduct: 'service-plan',
        }),
      },
      {
        label: 'Core: Letters merge',
        to: getProductHyperlink({
          environment: ENV.ENVIRONMENT,
          product: 'core',
          subProduct: 'letters',
        }),
      },
      {
        label: 'Core: Resources',
        to: getProductHyperlink({
          environment: ENV.ENVIRONMENT,
          product: 'core',
          subProduct: 'resources',
        }),
      },
    ],
    icon: <Icon icon={<UsersIcon />} />,
  },
  {
    title: 'Practice operations',
    description:
      'Templates and guidelines to help standardise processes and uphold quality management practices within your firm.',
    tags: [
      {
        label: 'Core: Collate',
        to: getProductHyperlink({
          environment: ENV.ENVIRONMENT,
          product: 'core',
          subProduct: 'collate',
        }),
      },
      {
        label: 'Core: Actions',
        to: getProductHyperlink({
          environment: ENV.ENVIRONMENT,
          product: 'core',
          subProduct: 'meetings',
        }),
      },
      {
        label: 'Core: Resources',
        to: getProductHyperlink({
          environment: ENV.ENVIRONMENT,
          product: 'core',
          subProduct: 'resources',
        }),
      },
    ],
    icon: <Icon icon={<InstitutionIcon />} />,
  },
];
